//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  components: {},
  data () {
    return {
      user: {
        userId: ''
      },
      info: {
        id: '',
        title: '',
        author: '',
        time: '',
        img: '',
        imgList: [],
        fcontent: '',
        scontent: '',
        url: ''
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.user = vm.$store.state.sx.user || vm.user
      vm.$post('article/detail', {
        id: to.params.id,
        type: to.params.type,
        userId: vm.user.userId
      }, (res) => {
        if (res.code === 200) {
          for (let item in res.data) {
            if (res.data[item] !== undefined && res.data[item] !== null) {
              vm.info[item] = res.data[item]
            }
          }

          if (vm.$isWechat()) {
            let shareLink = window.location.href
            let shareDesc = vm.info.author
            let shareImage = vm.info.img
            if (!shareImage && vm.info.imgList && vm.info.imgList.length) {
              shareImage = vm.info.imgList[0]
            }
            vm.$wechatShare(null, shareLink, vm.info.title, shareDesc, shareImage)
          }
        }
      })
    })
  },
  methods: {
  }
}



// WEBPACK FOOTER //
// ./src/page/ArticleView.vue